export enum StorageKey {
  sessionStorageKey = "blog-session",
  localStorageKey = "blog-local",
}
